// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConstants } from '@app/utils';
import { HttpClient } from '@angular/common/http';
import { LMLoggerService } from './lm-logger.service';

@Injectable()
export class LMRelatedActionsService {
  constructor(
    private httpClient: HttpClient,
    private lmLoggerService: LMLoggerService
  ) {}

    public getRelatedActionMenuItems(relationActionUrl: string): Observable<RelatedMenuItemResponse> {
    return new Observable<RelatedMenuItemResponse> (observer => {
      this.httpClient
        .get(relationActionUrl).pipe(
          catchError(error => {
            this.lmLoggerService.error(error);
            return throwError(error || 'Server error');
          }))
        .subscribe((res: any) => {
          this.lmLoggerService.log('Related DataViewSet retrieved');
          if (res?.actionSpec?.type === AppConstants.ACTION_TYPE_CREATE
          ||  res?.actionSpec?.type === AppConstants.ACTION_TYPE_SET
          ||  res?.actionSpec?.type === AppConstants.ACTION_TYPE_IMPORT) {
            const headerRelMenItem: RelatedMenuItem[] = [ {
              text: res.dataViewSet.header.representativeText,
              resourceId: res.dataViewSet.header.resourceId
            } ];
            observer.next({
              dataViewSet: res.dataViewSet,
              actionSpec: res.actionSpec,
              hasActionForm: res.hasActionForm,
              relatedMenuItems: headerRelMenItem
            });
            observer.complete();
          } else {
            let i = 0;
            const relMenuItems: RelatedMenuItem[] = [];
            const dataViewSet = res.dataViewSet;
            dataViewSet.data.forEach(dataView => {
              relMenuItems[ i++ ] = { text: dataView.representativeText, resourceId: dataView.resourceId };
            });
            observer.next({ dataViewSet: dataViewSet, actionSpec: res.actionSpec, hasActionForm: res.hasActionForm, relatedMenuItems: relMenuItems });
            observer.complete();
          }
        });
    });
  }

    /**
     * A called-out related action of the form `action is BusinessClass.ActionName` targets a
     * DIFFERENT business class than the host. It is emitted as a related action with a populated
     * relBusClass and a CREATE actionSpec. Such a button is a direct Create action, not a
     * related-records menu. See LMWEB-25175.
     */
    // GenAI Generated code - Start
    public isRelatedBusClassCreate(actionReference: LMBusActionReference): boolean {
        if (!actionReference) {
            return false;
        }

        const targetsAnotherBusClass = !!actionReference.relBusClass;
        const isCreateAction = actionReference.actionSpec?.type === AppConstants.ACTION_TYPE_CREATE;

        return targetsAnotherBusClass && isCreateAction && actionReference.relation === '';
    }
    // GenAI Generated code - End
}
